import React, {useEffect, useRef, useState} from 'react';
import {bindActionCreators} from 'redux';
import TextInput from '../../Shared/TextInput/TextInput';
import Checkbox from '../../Shared/CheckBox/Checkbox';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import Popup from '../../Shared/Popup/PopUp';
import ExtendedLeadSuccess from './extendedLeadSuccess';
import FilesUpload from './extendedLeadFilesUpload';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import {
  setInitialContent,
  setShowPopup,
  createLead,
  setFormField,
  addFormFile,
  removeFormFile,
  openOpportunity,
  resetBlock,
  setAgreementsCheckBox,
} from './extendedLeadBlockSlice';
import {getBackgroundImageProps} from '../../../utilities/ImageProps';
import {isMobile} from 'react-device-detect';
import {connect} from 'react-redux';
import Config from '../../../Config';
import LeadAgreementsTooltip from '../../Shared/LeadAgreementsTooltip/LeadAgreementsTooltip';
import {dwhExtendedLead} from './dwhReports';
import {gtag4} from '../../../utilities/analytics/tracking';
import helper from '../../../utilities/helper';

const ExtendedLead = (props) => {
  const subjectSelectRef = useRef();
  const isHaveBackground = props['backgroundImage']?.style != undefined ? true : false;
  const isHorizontalMode = !isMobile && props.iContent?.isHorizontalMode?.value;
  const isHaveLegalText = useRef(false);
  const [toolTipIsOpen, setToolTipIsOpen] = useState(false);
  const env_num = props.headerData?.tabIndex;
  const [envType, setEnvType] = useState('init');
  const defaultColorForFormType = isHorizontalMode ? 'black' : 'gradient';
  const bgColors = ['black', 'white', 'purple', 'lightPurple', 'gradient'];
  const bgColor =
    (isMobile ? bgColors[props.iContent.backgroundColorLeadMobile.value] : bgColors[props.iContent.backgroundColorLeadDesktop.value]) ??
    defaultColorForFormType;
  const btnColor =
    (isMobile ? bgColors[props.iContent.btnColorLeadMobile.value] : bgColors[props.iContent.btnColorLeadDesktop.value]) ?? 'purple';
  const extendedLead = props.extendedLead;
  const contentData = extendedLead?.contentData;
  const form = extendedLead?.form;
  const sendButtonText = contentData?.leadSendButton || 'שלח';

  const leadAgreementsData = {
    leadAgreementsCheckBox: props.iContent.leadAgreementsCheckBox?.value,
    defaulText: Config.potentialCustomerDefaulText,
    tooltipText: Config.potentialCustomerTooltipText,
    bottomText: Config.potentialCustomerBottomText,
    textButton: Config.potentialCustomerTextButton,
    leadsubject: props.iContent.leadsubject.value,
  };

  useEffect(() => {
    if (leadAgreementsData.leadAgreementsCheckBox) {
      gtag4({
        event: 'ExtendedLeadBlock_Imp',
        title: extendedLead?.contentData.title,
        section: leadAgreementsData.leadsubject,
      });
    }
  }, []);

  useEffect(() => {
    if (env_num == 0) setEnvType('private');
    if (env_num == 1) setEnvType('buisness');
  }, [env_num]);

  useEffect(() => {
    props.actions.setInitialContent(props.iContent);
    props.actions.setAgreementsCheckBox(leadAgreementsData.leadAgreementsCheckBox);
    return () => {
      props.actions.resetBlock();
    };
  }, []);

  useEffect(() => {
    if (props.extendedLead.form.subjectIndex) {
      subjectSelectRef.current.selectedIndex = props.extendedLead.form.subjectIndex;
    }
  }, [props.extendedLead.form.subjectIndex]);

  function handlePopupClose() {
    props.actions.setShowPopup(false);
  }

  function handleInputChange(e) {
    const name = e.target.getAttribute('name');
    const rule = props.extendedLead?.form?.rules[name];
    let value;

    switch (e.target.type) {
      case 'checkbox':
        value = e.target.checked;
        break;
      case 'select-one':
        value = e.target.options.selectedIndex;
        break;
      default:
        value = e.target.value;
        break;
    }

    props.actions.setFormField({
      name,
      value,
      rule,
    });
  }

  function onFileAdded(fileNameObj) {
    props.actions.addFormFile(fileNameObj);
  }

  function onFileRemoved(fileName) {
    props.actions.removeFormFile(fileName);
  }

  const handleLeadResult = (result) => {
    const subjectObj = props.extendedLead.contentData.subjectList[props.extendedLead.form.subjectIndex - 1];
    const subjectCode = subjectObj.subjectCode;
    const subjectName = subjectObj.subjectName;

    if (result && result.payload?.isSuccess) {
      gtag4({
        event: 'ExtendedLeadBlock_FormSubmit',
        title: extendedLead?.contentData.title,
        section: leadAgreementsData.leadsubject,
        button: sendButtonText,
        content: subjectName,
      });
    } else if (!result || !result.payload?.isSuccess) {
      handleDwh('sendError');
      gtag4({
        event: 'ExtendedLeadBlock_ErrorMessage',
        title: extendedLead?.contentData?.title,
        section: leadAgreementsData?.leadsubject,
        error: result.payload?.returnCodeMessage,
      });
    } else if (result && !result?.payload?.collaborationUpdateSuccess && leadAgreementsData.leadAgreementsCheckBox) {
      handleDwh('updateApprovalError');
    }
  };

  async function handleSubmit(e) {
    e.preventDefault();

    handleDwh('ButtonClicked');

    const subjectObj = props.extendedLead.contentData.subjectList[props.extendedLead.form.subjectIndex - 1];
    const isOpenOpportunity = !!subjectObj?.isOpenOpportunity;

    if (isOpenOpportunity) {
      const result = await props.actions.openOpportunity();
      handleLeadResult(result);
    } else {
      const utmParams = [];
      props.iContent?.utmParams?.value?.forEach((paramName) => {
        utmParams.push({name: paramName, value: helper.getUrlParameter(paramName)});
      });

      const result = await props.actions.createLead({utmParams});
      handleLeadResult(result);
    }
  }

  const handleDwh = (type) => {
    switch (type) {
      case 'ButtonClicked':
        dwhExtendedLead(
          'Completed',
          'Extended Lead Block Button Clicked',
          `${leadAgreementsData.leadAgreementsCheckBox}`,
          leadAgreementsData.leadsubject,
          form?.firstName,
          form?.lastName,
          form?.identity,
          form?.payment,
          form?.phoneNumber,
          form?.emailAddress,
        );
        break;
      case 'updateApprovalError':
        dwhExtendedLead(
          'Error',
          'Update Approval Consent Error',
          'true',
          leadAgreementsData.leadsubject,
          form?.firstName,
          form?.lastName,
          form?.identity,
          form?.payment,
          form?.phoneNumber,
          form?.emailAddress,
        );
        break;
      case 'sendError':
        dwhExtendedLead(
          'Error',
          'Send Lead Error',
          `${leadAgreementsData.leadAgreementsCheckBox}`,
          leadAgreementsData.leadsubject,
          form?.firstName,
          form?.lastName,
          form?.identity,
          form?.payment,
          form?.phoneNumber,
          form?.emailAddress,
        );
        break;
      default:
        break;
    }
  };

  function handleTooltipStatus(toolTipStatus) {
    setToolTipIsOpen(toolTipStatus);
  }

  /* setting default legal text if not overrided by Content editor */
  let legalText = (
    <p>
        {
          Config.loginPageLegalText &&
          <span dangerouslySetInnerHTML={{ __html: Config.loginPageLegalText }}></span>
        }      
    </p>
  );
  if (isHorizontalMode) {
    legalText = (
      <div className='textContainer'>
        {
          Config.loginPageLegalText &&
          <span className='termsText' dangerouslySetInnerHTML={{ __html: Config.loginPageLegalText }}></span>
        }          
      </div>
    );
  }
  if (props.iContent?.legalText?.value && props.iContent?.legalText.value != '') {
    isHaveLegalText.current = true;
    legalText = <div dangerouslySetInnerHTML={{__html: props.iContent?.legalText.value}}></div>;
  }

  let currentView = (
    <>
      {extendedLead?.showSuccess ? (
        <div className={`layout-wrapper layout-bg-${bgColor}`}>
          <ExtendedLeadSuccess
            title={contentData?.successTitle}
            subtitle={contentData?.successSubTitle}
            ticketNumber={props.extendedLead?.ticketNumber}
            sla={props.extendedLead?.sla}
            slaColor={props.iContent?.slaColor?.value}
            lead_type={envType}
            form_list={contentData?.subjectList[form?.subjectIndex]}
          />
        </div>
      ) : (
        <div className={`layout-wrapper layout-bg-${bgColor}`}>
          <div className='topContainer'>
            <div className='container'>
              <div className='row'>
                <div className='col-12'>
                  <h1>{contentData?.title}</h1>
                </div>
              </div>
              <div className='row'>
                <div className='col-12'>
                  <h2>{contentData?.subTitle}</h2>
                </div>
              </div>
              {contentData?.topText && (
                <div className='row'>
                  <div className='col-12'>
                    <div className='pt-2' dangerouslySetInnerHTML={{__html: contentData?.topText}}></div>
                  </div>
                </div>
              )}
              <div className='row'>
                <div className='col-12'>
                  <form onSubmit={handleSubmit}>
                    <div className='form-inputs-container'>
                      <span className='required-fields-text'>שדות עם כוכבית הם חובה</span>
                      {contentData?.isShowFirstName && (
                        <TextInput
                          error={form?.errors?.firstName}
                          onChange={handleInputChange}
                          value={form?.firstName}
                          type='text'
                          placeholder={contentData?.firstNameLabel}
                          id='firstName'
                          name='firstName'
                          maxLength='16'
                          autoComplete='off'
                          required={contentData?.isFirstNameRequired ? 'required' : ''}
                        />
                      )}
                      {contentData?.isShowLastName && (
                        <TextInput
                          error={form?.errors?.lastName}
                          onChange={handleInputChange}
                          value={form?.lastName}
                          type='text'
                          placeholder={contentData?.lastNameLabel}
                          id='lastName'
                          name='lastName'
                          maxLength='16'
                          autoComplete='off'
                          required={contentData?.isLastNameRequired ? 'required' : ''}
                        />
                      )}
                      {contentData?.isShowIdentity && (
                        <TextInput
                          error={form?.errors?.identity}
                          onChange={handleInputChange}
                          value={form?.identity}
                          type='text'
                          placeholder={contentData?.identityLabel}
                          id='identity'
                          name='identity'
                          maxLength='9'
                          autoComplete='off'
                          required={contentData?.isIdentityRequired ? 'required' : ''}
                        />
                      )}
                      {contentData?.isShowPayment && (
                        <TextInput
                          error={form?.errors?.payment}
                          onChange={handleInputChange}
                          value={form?.payment}
                          type='tel'
                          placeholder={contentData?.paymentLabel}
                          id='payment'
                          name='payment'
                          maxLength='20'
                          autoComplete='off'
                          required={contentData?.isPaymentRequired ? 'required' : ''}
                        />
                      )}
                      {contentData?.isShowPhone && (
                        <TextInput
                          error={form?.errors?.phoneNumber}
                          onChange={handleInputChange}
                          value={form?.phoneNumber}
                          type='tel'
                          placeholder={contentData?.phoneLabel}
                          id='phoneNumber'
                          name='phoneNumber'
                          maxLength='10'
                          autoComplete='off'
                          required={contentData?.isPhoneRequired ? 'required' : ''}
                        />
                      )}
                      {contentData?.isShowAdditionalPhone && (
                        <TextInput
                          error={form?.errors?.additionalPhone}
                          onChange={handleInputChange}
                          value={form?.additionalPhone}
                          type='tel'
                          placeholder={contentData?.additionalPhoneLabel}
                          id='additionalPhone'
                          name='additionalPhone'
                          maxLength='10'
                          autoComplete='off'
                          required={contentData?.isAdditionalPhoneRequired ? 'required' : ''}
                        />
                      )}
                      {contentData?.isShowEmail && (
                        <TextInput
                          error={form?.errors?.emailAddress}
                          onChange={handleInputChange}
                          value={form?.emailAddress}
                          type='text'
                          placeholder={contentData?.emailLabel}
                          id='emailAddress'
                          name='emailAddress'
                          maxLength='40'
                          autoComplete='off'
                          required={contentData?.isEmailRequired ? 'required' : ''}
                        />
                      )}
                      {contentData?.isShowCompanyName && (
                        <TextInput
                          error={form?.errors?.companyName}
                          onChange={handleInputChange}
                          value={form?.companyName}
                          type='text'
                          placeholder={contentData?.companyNameLabel}
                          id='companyName'
                          name='companyName'
                          maxLength='40'
                          autoComplete='off'
                          required={contentData?.isCompanyNameRequired ? 'required' : ''}
                        />
                      )}
                      <TextInput
                        error={form?.errors?.subjectIndex}
                        onChange={handleInputChange}
                        type='select'
                        placeholder={contentData?.subjectListLabel}
                        id='subjectIndex'
                        ref={subjectSelectRef}
                        name='subjectIndex'
                        autoComplete='off'
                        required={'required'}>
                        <option key='choose' value=''>
                          בחר
                        </option>
                        {contentData?.subjectList?.map((subject, index) => (
                          <option key={index} value={subject.subjectCode}>
                            {subject.subjectName}
                          </option>
                        ))}
                      </TextInput>
                      {contentData?.isShowContent && (
                        <TextInput
                          error={form?.errors?.content}
                          onChange={handleInputChange}
                          value={form?.content}
                          type='textarea'
                          placeholder={contentData?.contentLabel}
                          id='content'
                          name='content'
                          maxLength='300'
                          autoComplete='off'
                          required={contentData?.isContentRequired ? 'required' : ''}
                        />
                      )}
                      {contentData?.isShowGeneralField && (
                        <TextInput
                          error={form?.errors?.generalField}
                          onChange={handleInputChange}
                          value={form?.generalField}
                          type='text'
                          placeholder={contentData?.generalFieldLabel}
                          id='generalField'
                          name='generalField'
                          maxLength='40'
                          autoComplete='off'
                          required={contentData?.isGeneralFieldRequired ? 'required' : ''}
                        />
                      )}
                      {contentData?.isShowUploadFiles && (
                        <FilesUpload
                          files={form?.uploadFiles}
                          supportedFileExtensions={contentData?.uploadFilesExtensions}
                          maxFilesToUpload={contentData?.maxFilesToUpload}
                          additionalText={contentData?.uploadFilesExplanationText}
                          onFileAdded={onFileAdded}
                          onFileRemoved={onFileRemoved}
                          onFileStartLoading={props.actions.showAppLoader}
                          onFileFinishLoading={props.actions.hideAppLoader}
                        />
                      )}
                      <div className='CheckboxTerms'>
                        {contentData?.isShowTerms && (
                          <Checkbox
                            error={form?.errors?.terms}
                            onChange={handleInputChange}
                            id='terms'
                            name='terms'
                            checked={form?.terms ? 'checked' : ''}
                            required={contentData?.isTermsRequired ? 'required' : ''}>
                            <div dangerouslySetInnerHTML={{__html: contentData?.termsText}}></div>
                          </Checkbox>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className='bottomContainer'>
            <div className='layoutBottom'>
              <div className='container'>
                {extendedLead?.showError && <div className='pt-2' dangerouslySetInnerHTML={{__html: contentData?.failureText}}></div>}
                {contentData?.bottomText && (
                  <div className='row'>
                    <div className='col-12'>
                      <div className='pt-2' dangerouslySetInnerHTML={{__html: contentData?.bottomText}}></div>
                    </div>
                  </div>
                )}

                <div className='textContainer'>
                  {leadAgreementsData?.leadAgreementsCheckBox ? (
                    <div className='lead-agreements-container'>
                      <div className='col-12'>
                        <LeadAgreementsTooltip leadAgreementsData={leadAgreementsData} sendTooltipStatus={handleTooltipStatus} />
                      </div>
                    </div>
                  ) : (
                    legalText
                  )}
                </div>
                {!toolTipIsOpen && (
                  <div className='buttonContainer'>
                    <BtnSubmit
                      onclick={handleSubmit}
                      text={sendButtonText}
                      formid='extendedLeadForm'
                      className={`submit-btn-${btnColor}`}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );

  //isHorizontalMode
  if (isHorizontalMode) {
    if (leadAgreementsData.leadAgreementsCheckBox) {
      currentView = (
        <>
          <div className={`layout-wrapper layout-bg-${bgColor}`}>
            {extendedLead?.showSuccess ? (
              <>
                <ExtendedLeadSuccess
                  title={contentData?.successTitle}
                  subtitle={contentData?.successSubTitle}
                  ticketNumber={props.extendedLead?.ticketNumber}
                  sla={props.extendedLead?.sla}                  
                  slaColor={props.iContent?.slaColor?.value}
                  lead_type={envType}
                  form_list={contentData?.subjectList[form?.subjectIndex]}
                />
              </>
            ) : (
              <>
                <div
                  className='topContainerHorizontal'
                  style={isHaveBackground ? {backgroundImage: props['backgroundImage'].style.backgroundImage} : {}}></div>

                <div className='bottomContainerHorizontal'>
                  {extendedLead?.showError && (
                    <div className='errorHorizontal' dangerouslySetInnerHTML={{__html: contentData?.failureText}}></div>
                  )}
                  <p className='subject'>{contentData?.title}</p>
                  <div className='containerHorizontal'>
                    <form id='extendedLeadForm'>
                      <div className='row lead-agreements-mode'>
                        {contentData?.isShowFirstName && (
                          <div className='col-md-3'>
                            <TextInput
                              error={form?.errors?.firstName}
                              onChange={handleInputChange}
                              value={form?.firstName}
                              type='text'
                              placeholder={contentData?.firstNameLabel}
                              id='firstName'
                              name='firstName'
                              maxLength='16'
                              autoComplete='off'
                              required={contentData?.isFirstNameRequired ? 'required' : ''}
                            />
                          </div>
                        )}
                        {contentData?.isShowLastName && (
                          <div className='col-md-3'>
                            <TextInput
                              error={form?.errors?.lastName}
                              onChange={handleInputChange}
                              value={form?.lastName}
                              type='text'
                              placeholder={contentData?.lastNameLabel}
                              id='lastName'
                              name='lastName'
                              maxLength='16'
                              autoComplete='off'
                              required={contentData?.isLastNameRequired ? 'required' : ''}
                            />
                          </div>
                        )}
                        {contentData?.isShowIdentity && (
                          <div className='col-md-3'>
                            <TextInput
                              error={form?.errors?.identity}
                              onChange={handleInputChange}
                              value={form?.identity}
                              type='text'
                              placeholder={contentData?.identityLabel}
                              id='identity'
                              name='identity'
                              maxLength='9'
                              autoComplete='off'
                              required={contentData?.isIdentityRequired ? 'required' : ''}
                            />
                          </div>
                        )}
                        {contentData?.isShowPayment && (
                          <div className='col-md-3'>
                            <TextInput
                              error={form?.errors?.payment}
                              onChange={handleInputChange}
                              value={form?.payment}
                              type='tel'
                              placeholder={contentData?.paymentLabel}
                              id='payment'
                              name='payment'
                              maxLength='20'
                              autoComplete='off'
                              required={contentData?.isPaymentRequired ? 'required' : ''}
                            />
                          </div>
                        )}

                        {contentData?.isShowPhone && (
                          <div className='col-md-3'>
                            <TextInput
                              error={form?.errors?.phoneNumber}
                              onChange={handleInputChange}
                              value={form?.phoneNumber}
                              type='tel'
                              placeholder={contentData?.phoneLabel}
                              id='phoneNumber'
                              name='phoneNumber'
                              maxLength='10'
                              autoComplete='off'
                              required={contentData?.isPhoneRequired ? 'required' : ''}
                            />
                          </div>
                        )}
                        {contentData?.isShowAdditionalPhone && (
                          <div className='col-md-3'>
                            <TextInput
                              error={form?.errors?.additionalPhone}
                              onChange={handleInputChange}
                              value={form?.additionalPhone}
                              type='tel'
                              placeholder={contentData?.additionalPhoneLabel}
                              id='additionalPhone'
                              name='additionalPhone'
                              maxLength='10'
                              autoComplete='off'
                              required={contentData?.isAdditionalPhoneRequired ? 'required' : ''}
                            />
                          </div>
                        )}
                        {contentData?.isShowEmail && (
                          <div className='col-md-3'>
                            <TextInput
                              error={form?.errors?.emailAddress}
                              onChange={handleInputChange}
                              value={form?.emailAddress}
                              type='text'
                              placeholder={contentData?.emailLabel}
                              id='emailAddress'
                              name='emailAddress'
                              maxLength='40'
                              autoComplete='off'
                              required={contentData?.isEmailRequired ? 'required' : ''}
                            />
                          </div>
                        )}
                        {contentData?.isShowCompanyName && (
                          <div className='col-md-3'>
                            <TextInput
                              error={form?.errors?.companyName}
                              onChange={handleInputChange}
                              value={form?.companyName}
                              type='text'
                              placeholder={contentData?.companyNameLabel}
                              id='companyName'
                              name='companyName'
                              maxLength='40'
                              autoComplete='off'
                              required={contentData?.isCompanyNameRequired ? 'required' : ''}
                            />
                          </div>
                        )}

                        <div className='col-md-3'>
                          <TextInput
                            error={form?.errors?.subjectIndex}
                            onChange={handleInputChange}
                            type='select'
                            placeholder={contentData?.subjectListLabel}
                            id='subjectIndex'
                            ref={subjectSelectRef}
                            name='subjectIndex'
                            autoComplete='off'
                            required={'required'}>
                            <option key='choose' value=''>
                              בחר
                            </option>
                            {contentData?.subjectList?.map((subject, index) => (
                              <option key={index} value={subject.subjectCode}>
                                {subject.subjectName}
                              </option>
                            ))}
                          </TextInput>
                        </div>
                        {contentData?.isShowGeneralField && (
                          <div className='col-md-3'>
                            <TextInput
                              error={form?.errors?.generalField}
                              onChange={handleInputChange}
                              value={form?.generalField}
                              type='text'
                              placeholder={contentData?.generalFieldLabel}
                              id='generalField'
                              name='generalField'
                              maxLength='40'
                              autoComplete='off'
                              required={contentData?.isGeneralFieldRequired ? 'required' : ''}
                            />
                          </div>
                        )}
                        {contentData?.isShowUploadFiles && (
                          <div className='col-md-3'>
                            <FilesUpload
                              files={form?.uploadFiles}
                              supportedFileExtensions={contentData?.uploadFilesExtensions}
                              maxFilesToUpload={contentData?.maxFilesToUpload}
                              additionalText={contentData?.uploadFilesExplanationText}
                              onFileAdded={onFileAdded}
                              onFileRemoved={onFileRemoved}
                              onFileStartLoading={props.actions.showAppLoader}
                              onFileFinishLoading={props.actions.hideAppLoader}
                            />
                          </div>
                        )}

                        {contentData?.isShowContent && (
                          <div className='col-md-3'>
                            <TextInput
                              error={form?.errors?.content}
                              onChange={handleInputChange}
                              value={form?.content}
                              type='textarea'
                              placeholder={contentData?.contentLabel}
                              id='content'
                              name='content'
                              maxLength='300'
                              autoComplete='off'
                              required={contentData?.isContentRequired ? 'required' : ''}
                            />
                          </div>
                        )}
                      </div>
                      {contentData?.bottomText ? (
                        <>
                          <div class='row'>
                            <div
                              class='col col-bottomText'
                              style={{marginTop: 0}}
                              dangerouslySetInnerHTML={{__html: contentData?.bottomText}}></div>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                      <div className='row horizontal-lead-agreements-container'>
                        <LeadAgreementsTooltip
                          leadAgreementsData={leadAgreementsData}
                          isHorizontalMode={true}
                          additionalBottomText={`${contentData?.bottomText ? 'additional-bottomText' : ''}`}
                        />
                        <div className='buttonContainer agreementsCheckBoxActive'>
                          <BtnSubmit
                            className={`btn-submit agreementsCheckBoxActive submit-btn-${btnColor}`}
                            onclick={handleSubmit}
                            text={sendButtonText}
                            formid='extendedLeadForm'
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </>
            )}
          </div>
        </>
      );
    } else {
      currentView = (
        <>
          <div className={`layout-wrapper layout-bg-${bgColor}`}>
            {extendedLead?.showSuccess ? (
              <>
                <ExtendedLeadSuccess
                  title={contentData?.successTitle}
                  subtitle={contentData?.successSubTitle}
                  ticketNumber={props.extendedLead?.ticketNumber}
                  sla={props.extendedLead?.sla}
                  slaColor={props.iContent?.slaColor?.value}
                  lead_type={envType}
                  form_list={contentData?.subjectList[form?.subjectIndex]}
                />
              </>
            ) : (
              <>
                <div
                  className='topContainerHorizontal'
                  style={isHaveBackground ? {backgroundImage: props['backgroundImage'].style.backgroundImage} : {}}></div>

                <div className='bottomContainerHorizontal'>
                  {extendedLead?.showError && (
                    <div className='errorHorizontal' dangerouslySetInnerHTML={{__html: contentData?.failureText}}></div>
                  )}
                  <p className='subject'>{contentData?.title}</p>
                  <div class='containerHorizontal'>
                    <form id='extendedLeadForm'>
                      <div class='row'>
                        {contentData?.isShowFirstName && (
                          <div class='col'>
                            <TextInput
                              error={form?.errors?.firstName}
                              onChange={handleInputChange}
                              value={form?.firstName}
                              type='text'
                              placeholder={contentData?.firstNameLabel}
                              id='firstName'
                              name='firstName'
                              maxLength='16'
                              autoComplete='off'
                              required={contentData?.isFirstNameRequired ? 'required' : ''}
                            />
                          </div>
                        )}
                        {contentData?.isShowLastName && (
                          <div class='col'>
                            <TextInput
                              error={form?.errors?.lastName}
                              onChange={handleInputChange}
                              value={form?.lastName}
                              type='text'
                              placeholder={contentData?.lastNameLabel}
                              id='lastName'
                              name='lastName'
                              maxLength='16'
                              autoComplete='off'
                              required={contentData?.isLastNameRequired ? 'required' : ''}
                            />
                          </div>
                        )}
                        {contentData?.isShowIdentity && (
                          <div class='col'>
                            <TextInput
                              error={form?.errors?.identity}
                              onChange={handleInputChange}
                              value={form?.identity}
                              type='text'
                              placeholder={contentData?.identityLabel}
                              id='identity'
                              name='identity'
                              maxLength='9'
                              autoComplete='off'
                              required={contentData?.isIdentityRequired ? 'required' : ''}
                            />
                          </div>
                        )}
                        {contentData?.isShowPayment && (
                          <div class='col'>
                            <TextInput
                              error={form?.errors?.payment}
                              onChange={handleInputChange}
                              value={form?.payment}
                              type='tel'
                              placeholder={contentData?.paymentLabel}
                              id='payment'
                              name='payment'
                              maxLength='20'
                              autoComplete='off'
                              required={contentData?.isPaymentRequired ? 'required' : ''}
                            />
                          </div>
                        )}
                        {contentData?.isShowPhone && (
                          <div class='col'>
                            <TextInput
                              error={form?.errors?.phoneNumber}
                              onChange={handleInputChange}
                              value={form?.phoneNumber}
                              type='tel'
                              placeholder={contentData?.phoneLabel}
                              id='phoneNumber'
                              name='phoneNumber'
                              maxLength='10'
                              autoComplete='off'
                              required={contentData?.isPhoneRequired ? 'required' : ''}
                            />
                          </div>
                        )}
                        {contentData?.isShowAdditionalPhone && (
                          <div class='col'>
                            <TextInput
                              error={form?.errors?.additionalPhone}
                              onChange={handleInputChange}
                              value={form?.additionalPhone}
                              type='tel'
                              placeholder={contentData?.additionalPhoneLabel}
                              id='additionalPhone'
                              name='additionalPhone'
                              maxLength='10'
                              autoComplete='off'
                              required={contentData?.isAdditionalPhoneRequired ? 'required' : ''}
                            />
                          </div>
                        )}
                        {contentData?.isShowEmail && (
                          <div class='col'>
                            <TextInput
                              error={form?.errors?.emailAddress}
                              onChange={handleInputChange}
                              value={form?.emailAddress}
                              type='text'
                              placeholder={contentData?.emailLabel}
                              id='emailAddress'
                              name='emailAddress'
                              maxLength='40'
                              autoComplete='off'
                              required={contentData?.isEmailRequired ? 'required' : ''}
                            />
                          </div>
                        )}
                        {contentData?.isShowCompanyName && (
                          <div class='col'>
                            <TextInput
                              error={form?.errors?.companyName}
                              onChange={handleInputChange}
                              value={form?.companyName}
                              type='text'
                              placeholder={contentData?.companyNameLabel}
                              id='companyName'
                              name='companyName'
                              maxLength='40'
                              autoComplete='off'
                              required={contentData?.isCompanyNameRequired ? 'required' : ''}
                            />
                          </div>
                        )}
                        <div class='col'>
                          <TextInput
                            error={form?.errors?.subjectIndex}
                            onChange={handleInputChange}
                            type='select'
                            placeholder={contentData?.subjectListLabel}
                            id='subjectIndex'
                            ref={subjectSelectRef}
                            name='subjectIndex'
                            autoComplete='off'
                            required={'required'}>
                            <option key='choose' value=''>
                              בחר
                            </option>
                            {contentData?.subjectList?.map((subject, index) => (
                              <option key={index} value={subject.subjectCode}>
                                {subject.subjectName}
                              </option>
                            ))}
                          </TextInput>
                        </div>

                        {contentData?.isShowGeneralField && (
                          <div class='col'>
                            <TextInput
                              error={form?.errors?.generalField}
                              onChange={handleInputChange}
                              value={form?.generalField}
                              type='text'
                              placeholder={contentData?.generalFieldLabel}
                              id='generalField'
                              name='generalField'
                              maxLength='40'
                              autoComplete='off'
                              required={contentData?.isGeneralFieldRequired ? 'required' : ''}
                            />
                          </div>
                        )}
                        {contentData?.isShowUploadFiles && (
                          <div class='col'>
                            <FilesUpload
                              files={form?.uploadFiles}
                              supportedFileExtensions={contentData?.uploadFilesExtensions}
                              maxFilesToUpload={contentData?.maxFilesToUpload}
                              additionalText={contentData?.uploadFilesExplanationText}
                              onFileAdded={onFileAdded}
                              onFileRemoved={onFileRemoved}
                              onFileStartLoading={props.actions.showAppLoader}
                              onFileFinishLoading={props.actions.hideAppLoader}
                            />
                          </div>
                        )}
                        <div class='col buttonContainer'>
                          <BtnSubmit
                            onclick={handleSubmit}
                            text={sendButtonText}
                            formid='extendedLeadForm'
                            className={`submit-btn-${btnColor}`}
                          />
                        </div>
                      </div>
                      {contentData?.isShowContent && (
                        <div class='row row-margin'>
                          <div class='col'>
                            <TextInput
                              error={form?.errors?.content}
                              onChange={handleInputChange}
                              value={form?.content}
                              type='textarea'
                              placeholder={contentData?.contentLabel}
                              id='content'
                              name='content'
                              maxLength='300'
                              autoComplete='off'
                              required={contentData?.isContentRequired ? 'required' : ''}
                            />
                          </div>
                        </div>
                      )}

                      <div class='row row-margin'>
                        {contentData?.isShowTerms && (
                          <>
                            <div class='col col-checkbox'>
                              <Checkbox
                                error={form?.errors?.terms}
                                onChange={handleInputChange}
                                id='terms'
                                name='terms'
                                checked={form?.terms ? 'checked' : ''}
                                required={contentData?.isTermsRequired ? 'required' : ''}>
                                <div class='col' dangerouslySetInnerHTML={{__html: contentData?.termsText}}></div>
                              </Checkbox>
                            </div>
                          </>
                        )}
                      </div>
                      {contentData?.bottomText ? (
                        <>
                          <div class='row'>
                            <div class='col col-bottomText' dangerouslySetInnerHTML={{__html: contentData?.bottomText}}></div>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}

                      <div class='row'>
                        {isHaveLegalText.current ? (
                          <div class='col col-legalText'>{legalText}</div>
                        ) : (
                          <div class='col col-legalTextDefault'>{legalText}</div>
                        )}
                      </div>
                    </form>
                  </div>
                </div>
              </>
            )}
          </div>
        </>
      );
    }
  }

  return <>{currentView}</>;
};

const mapStateToProps = (state) => {
  return {
    extendedLead: state.extendedLeadBlock,
    headerData: state.Header,
  };
};

const actionCreators = {
  setInitialContent,
  setShowPopup,
  createLead,
  openOpportunity,
  setFormField,
  addFormFile,
  removeFormFile,
  resetBlock,
  showAppLoader,
  hideAppLoader,
  setAgreementsCheckBox,
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actionCreators, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExtendedLead);
